import React from "react"
import { IconProps } from "types/icon"

const Cart: React.FC<IconProps> = ({
  size = "20",
  color = "currentColor",
  ...attributes
}) => {
  return (
    <>
      <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_39_113)">
          <path d="M0.833333 0.833252C0.373096 0.833252 0 1.20635 0 1.66659C0 2.12682 0.373096 2.49992 0.833333 2.49992H2.31608C2.43741 2.49992 2.55567 2.5381 2.65409 2.60904C2.75252 2.67999 2.82613 2.78011 2.86449 2.89521L5.61198 11.1392C5.73399 11.5053 5.7495 11.8994 5.65592 12.2737L5.42969 13.1803C5.09773 14.5081 6.13132 15.8333 7.5 15.8333H17.5C17.9602 15.8333 18.3333 15.4602 18.3333 14.9999C18.3333 14.5397 17.9602 14.1666 17.5 14.1666H7.5C7.17551 14.1666 6.9672 13.9003 7.0459 13.5855L7.21651 12.9041C7.24542 12.7886 7.31208 12.6862 7.40591 12.6129C7.49974 12.5397 7.61535 12.4999 7.73438 12.4999H16.6667C17.0255 12.5001 17.3441 12.2706 17.4577 11.9303L19.6794 5.26359C19.8593 4.72377 19.4574 4.16633 18.8883 4.16659H5.46224C5.34091 4.16659 5.22265 4.12841 5.12422 4.05747C5.02579 3.98652 4.95218 3.88641 4.91381 3.7713L4.12435 1.40291C4.0108 1.06255 3.69214 0.833064 3.33333 0.833252H0.833333ZM6.66667 16.6666C5.74619 16.6666 5 17.4128 5 18.3333C5 19.2537 5.74619 19.9999 6.66667 19.9999C7.58714 19.9999 8.33333 19.2537 8.33333 18.3333C8.33333 17.4128 7.58714 16.6666 6.66667 16.6666ZM16.6667 16.6666C15.7462 16.6666 15 17.4128 15 18.3333C15 19.2537 15.7462 19.9999 16.6667 19.9999C17.5871 19.9999 18.3333 19.2537 18.3333 18.3333C18.3333 17.4128 17.5871 16.6666 16.6667 16.6666Z" fill="currentColor" />
        </g>
        <defs>
          <clipPath id="clip0_39_113">
            <rect width={size} height={size} fill="white" />
          </clipPath>
        </defs>
      </svg>
    </>
  )
}

export default Cart
